<template>
  <div class="cookie-banner" v-if="!isCookiesBannerHide">
    <div class="cookie-banner-container">
      <div class="cookie-banner-title">{{ $t('message.cookieBanner.title') }}</div>
      <p class="cookie-banner-text">{{ $t('message.cookieBanner.text') }}</p>
      <p class="cookie-banner-policy">
        {{ $t('message.cookieBanner.policy') }}<router-link
          class="cookie-banner-policy-link"
          :to="{ name: 'documentsActive' }"
        >{{ $t('message.cookieBanner.policyLink') }}</router-link>
      </p>
      <div class="cookie-banner-actions">
        <div class="cookie-banner-btn-wrap">
          <base-button
            :text="$t('message.cookieBanner.decline')"
            @click="hideCookieBanner"
          />
        </div>
        <div class="cookie-banner-btn-wrap">
          <base-button
            :text="$t('message.cookieBanner.accept')"
            @click="hideCookieBanner"
          />
        </div>
      </div>
      <div class="cookie-banner-settings-block">
        <div class="cookie-banner-settings-row">
          <span
            class="cookie-banner-settings"
            @click="toggleSettings"
          >
            {{ $t('message.cookieBanner.settings') }}
          </span>
        </div>
        <div
          class="cookie-banner-options-wrap"
          :class="{ 'is-open': isSettingsOpen }"
        >
          <div class="cookie-banner-options">
            <div
              class="cookie-banner-option"
              v-for="option in cookieOptions"
              :key="option.key"
            >
              <p class="cookie-banner-option-text">
                {{ $t(`message.cookieBanner.options.${option.key}`) }}
              </p>
              <div
                class="cookie-banner-switch"
                :class="{
                  'cookie-banner-switch-checked': option.checked,
                  'cookie-banner-switch-disabled': option.disabled
                }"
                @click="toggleOption(option)"
              >
                <div class="cookie-banner-switch-thumb"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CookieBanner',
  data() {
    return {
      isCookiesBannerHide: localStorage.getItem('isCookiesBannerHide') === 'true',
      isSettingsOpen: false,
      cookieOptions: [
        {
          key: 'technical',
          checked: true,
          disabled: true
        },
        {
          key: 'analytics',
          checked: false,
          disabled: false
        },
        {
          key: 'advertising',
          checked: false,
          disabled: false
        }
      ]
    };
  },
  methods: {
    hideCookieBanner() {
      localStorage.setItem('isCookiesBannerHide', true);
      this.isCookiesBannerHide = true;
    },
    toggleSettings() {
      this.isSettingsOpen = !this.isSettingsOpen;
    },
    toggleOption(option) {
      if (option.disabled) {
        return;
      }
      option.checked = !option.checked;
    }
  }
};
</script>

<style lang="scss" scoped>
.cookie-banner {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 16px;
  z-index: 10050;
  display: flex;
  justify-content: center;
  max-height: 95%;
  box-sizing: border-box;
}

.cookie-banner-container {
  width: 50%;
  max-height: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px 28px;
  background-color: #fff;
  border: 1px solid #e2e3e3;
  border-radius: 20px;
  box-shadow: 0 12px 48px rgba(18, 18, 18, 0.28), 0 4px 12px rgba(18, 18, 18, 0.12);
  box-sizing: border-box;
  overflow-y: auto;
}

.cookie-banner-title {
  align-self: flex-start;
  margin: 0;
  color: #121212;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  text-align: left;
}

.cookie-banner-text {
  margin: 0;
  color: #121212;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
}

.cookie-banner-policy {
  margin: 0;
  color: #121212;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
}

.cookie-banner-policy-link {
  color: #41bf7b;
  text-decoration: underline;
  cursor: pointer;
}

.cookie-banner-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
}

.cookie-banner-btn-wrap {
  width: 140px;
  height: 40px;
}

.cookie-banner-settings-block {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.cookie-banner-settings-row {
  width: 100%;
  text-align: right;
}

.cookie-banner-settings {
  color: #878787;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  text-decoration: underline;
  cursor: pointer;
}

.cookie-banner-options-wrap {
  max-height: 0;
  overflow: hidden;
  opacity: 0;
  transform: translateY(16px);
  transition: max-height 0.35s ease, opacity 0.25s ease, transform 0.35s ease;
}

.cookie-banner-options-wrap.is-open {
  max-height: 800px;
  opacity: 1;
  transform: translateY(0);
}

.cookie-banner-options {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-top: 16px;
}

.cookie-banner-option {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 12px;
  background-color: #f8f8f8;
  border-radius: 10px;
  box-sizing: border-box;
}

.cookie-banner-option-text {
  margin: 0;
  color: #121212;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
}

.cookie-banner-switch {
  flex-shrink: 0;
  width: 44px;
  height: 24px;
  position: relative;
  background-color: #cdcdcd;
  border-radius: 12px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.cookie-banner-switch-checked {
  background-color: #41bf7b;
}

.cookie-banner-switch-disabled {
  cursor: default;
  opacity: 0.7;
}

.cookie-banner-switch-thumb {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
  background-color: #fff;
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(18, 18, 18, 0.2);
  transition: transform 0.2s ease;
}

.cookie-banner-switch-checked .cookie-banner-switch-thumb {
  transform: translateX(20px);
}

@media screen and (max-width: 640px) {
  .cookie-banner-container {
    width: 95%;
    padding: 16px;
  }

  .cookie-banner-actions {
    width: 100%;
    flex-direction: column;
  }

  .cookie-banner-btn-wrap {
    width: 100%;
  }
}
</style>
